import { UseCase } from '@domain/base/use-case';
import { TravelPlanModel } from '@domain/models/travel-plan.model';
import { TravelPlanRepository } from '@domain/repositories/travel-plan.repository';
import { Observable } from 'rxjs';


export class GetTravelPlanUseCase
  implements UseCase<{ id: string }, TravelPlanModel>
{
  constructor(private travelPlanRepository: TravelPlanRepository) {}

  execute(params: { id: string }): Observable<TravelPlanModel> {
    return this.travelPlanRepository.getPlan(params.id);
  }
}
